import PrivacyPolicyPage from "./PrivacyPolicyPage";
import authRoles from "../../auth/authRoles";

const PrivacyPolicyConfig = {
  settings: {
    layout: {
      config: {
        navbar: {
          display: false,
        },
        toolbar: {
          display: false,
        },
        footer: {
          display: false,
        },
        leftSidePanel: {
          display: false,
        },
        rightSidePanel: {
          display: false,
        },
      },
    },
  },
  auth: null,
  routes: [
    {
      path: "privacy-policy",
      element: <PrivacyPolicyPage />,
    },
  ],
};

export default PrivacyPolicyConfig;
